import Header from "../../Components/Header";
import { Link } from "react-router-dom";
import "./403.css"


export default function Forbidden() {


  return (
    <div className="home-wrapper">
            <Header />
    <div className="forbidden-wrapper">

      <h1>403</h1>
      <h3>Sorry, we can't let you in here...</h3>
      <h4>Try knocking at <Link to="/career">careers.beatspot.app</Link> and maybe we'll let you in.</h4>
      <h5>Until then - backend is king</h5>
    </div>
   </div>
  );
}
